<template>
</template>

<script>
    export default {};
</script>

<style lang="scss">
    .theme--light.v-application {
        background: transparent;
    }


    .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__expanded__row) > td.v-data-table__mobile-row {
        box-sizing: content-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        height: auto;
        padding: 10px;
        min-height: 32px;

        &:last-child {
            border-bottom: 8px solid rgba(240, 240, 240);
        }
    }

    .theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__expanded__row) > td.v-data-table__mobile-row {
        box-sizing: content-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        height: auto;
        padding: 10px;
        min-height: 32px;

        &:last-child {
            border-bottom: 8px solid #121212;
        }
    }

    .v-data-table tbody tr.v-data-table__expanded__content {
        box-shadow: none;
    }

    thead.v-data-table-header.v-data-table-header-mobile {
        display: none;
    }

    .v-text-field--outlined:not(.v-text-field--rounded) {
        border-radius: 0;
    }

    .pa-0 {
        padding: 0 !important;
    }

    .pa-t-0 {
        padding-top: 0 !important;
    }

    .pa-b-0 {
        padding-bottom: 0 !important;
    }

    .pa-l-0 {
        padding-left: 0 !important;
    }

    .pa-r-0 {
        padding-right: 0 !important;
    }

    .ma-0 {
        margin: 0 !important;
    }

    .ma-t-0 {
        margin-top: 0 !important;
    }

    .ma-b-0 {
        margin-bottom: 0 !important;
    }

    .ma-l-0 {
        margin-left: 0 !important;
    }

    .ma-r-0 {
        margin-right: 0 !important;
    }
</style>